import { RefStructureInfo } from '../../define/ref-structure-info';

export class RefStructureUtil {

    static serialize(refInfo: RefStructureInfo): Object {
        let result = new Object();
        result["id"] = refInfo.id;
        result["referId"] = refInfo.referId;
        result["referType"] = refInfo.referType;
        result["referCode"] = refInfo.referCode;
        result["structuredTypeId"] = refInfo.structuredTypeId;
        result["code"] = refInfo.code;
        result["name"] = refInfo.name;
        return result;
    }


    static deserialize(obj: Object): RefStructureInfo {
        let result = new RefStructureInfo();
        result.id = obj['id'];
        result.referId = obj['referId'];
        result.referType = obj['referType'];
        result.referCode = obj['referCode'];
        result.structuredTypeId = obj['structuredTypeId'];
        result.code = obj['code'];
        result.name = obj['name'];
        return result;

    }
}